module.exports = "/_next/static/images/OctoDiagram-lg@2x-1888aec5c3f6a165ebf3b99c71d3e360.png";